import type { JSX } from 'react';
import { allVehicles, type Vehicle } from '@bratva/content';
import type { SaveDoc } from '@bratva/state';
import { store } from '../game/store.js';

interface Props {
  save: SaveDoc;
  onClose(): void;
}

const rub = (kop: number): string => `${(kop / 100).toLocaleString('ru-RU')} ₽`;

/**
 * Гаражи: тачка — это не стат, а три вещи сразу. Дорога, багажник
 * и то, насколько ты бросаешься в глаза патрулю.
 */
export function GaragePanel({ save, onClose }: Props): JSX.Element {
  const buy = (vehicle: Vehicle): void =>
    store.dispatch({
      type: 'buyVehicle',
      def: vehicle.def,
      title: vehicle.title,
      price: vehicle.price,
      minutes: 30,
    });

  return (
    <div className="shop">
      <div className="deeds-head">
        <b>Тачки</b>
        <button type="button" className="deeds-close" onClick={onClose} aria-label="Закрыть">
          ✕
        </button>
      </div>

      <div className="shop-list">
        <div className="shop-item">
          <div className="shop-item-top">
            <span className="shop-item-title">Пешком</span>
            <span className="shop-item-price">{save.activeVehicle === null ? 'сейчас' : '—'}</span>
          </div>
          <span className="shop-item-meta">Дорога ×1.00 · хабар 2 · незаметно</span>
          {save.activeVehicle !== null && (
            <div className="shop-item-actions">
              <button type="button" onClick={() => store.dispatch({ type: 'setVehicle', def: null, title: '' })}>
                Оставить тачку
              </button>
            </div>
          )}
        </div>

        {allVehicles().map((vehicle) => {
          const owned = save.garage.includes(vehicle.def);
          const active = save.activeVehicle === vehicle.def;
          const affordable = save.player.cash >= vehicle.price;

          return (
            <div key={vehicle.def} className={active ? 'shop-item worn' : 'shop-item'}>
              <div className="shop-item-top">
                <span className="shop-item-title">{vehicle.title}</span>
                <span className="shop-item-price">{owned ? (active ? 'сейчас' : 'в гараже') : rub(vehicle.price)}</span>
              </div>
              <span className="shop-item-meta">
                дорога ×{vehicle.travelFactor.toFixed(2)} · хабар {vehicle.capacity} · авторитет +{vehicle.avtoritet} ·
                приметность {vehicle.flashiness > 0 ? '+'.repeat(vehicle.flashiness) : 'нет'}
              </span>
              {vehicle.hint && <span className="shop-item-hint">{vehicle.hint}</span>}

              <div className="shop-item-actions">
                {!owned && (
                  <button type="button" disabled={!affordable} onClick={() => buy(vehicle)}>
                    {affordable ? 'Купить' : 'Не хватает'}
                  </button>
                )}
                {owned && !active && (
                  <button
                    type="button"
                    onClick={() => store.dispatch({ type: 'setVehicle', def: vehicle.def, title: vehicle.title })}
                  >
                    Сесть за руль
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>

      <p className="shop-item-meta">
        Приметную тачку патруль замечает дальше: гелик режет дорогу вдвое, но и палево на нём растёт быстрее.
      </p>
    </div>
  );
}
